module.exports = __webpack_public_path__ + "static/img/4bg_9.3f54c0c.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/4bg_9.png
// module id = 720
// module chunks = 1